import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllDriverPayouts } from "../../Services/Payout.service";

// Thunks
export const fetchDriverPayouts = createAsyncThunk(
  "tariff/fetchDriverPayouts",
  async (forceRefresh = false, { getState, rejectWithValue }) => {
    const { tariff } = getState();
    if (!forceRefresh && tariff.driverPayouts.length > 0) {
      return tariff.driverPayouts;
    }
    try {
      const response = await getAllDriverPayouts({isPagination: false});
      if (response?.data?.list) return response.data.list;
      if (response?.data?.content) return response.data.content;
      return [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const tariffSlice = createSlice({
  name: "tariff",
  initialState: {
    driverPayouts: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Driver Payouts
    builder
      .addCase(fetchDriverPayouts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDriverPayouts.fulfilled, (state, action) => {
        state.loading = false;
        // Only update if we fetched new data (thunk might return existing state)
        if (action.payload !== state.driverPayouts) {
            state.driverPayouts = action.payload;
        }
      })
      .addCase(fetchDriverPayouts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default tariffSlice.reducer;
